import 'nprogress/nprogress.css' // 默认样式，可根据需要自定义样式
import './assets/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import 'vant/lib/index.css'
const app = createApp(App)
app.use(createPinia())
app.use(router)

app.mount('#app')
document.addEventListener('DOMContentLoaded', () => {
  const loadingElement = document.getElementById('app-loading')
  if (loadingElement) {
    loadingElement.style.opacity = '0'
    setTimeout(() => {
      loadingElement.parentNode.removeChild(loadingElement)
    }, 500) // 动画过渡时间
  }
})
